export default {"src":"/_next/static/media/icon-flag-ukraine.0d78c5ea.svg","height":27,"width":40,"blurWidth":0,"blurHeight":0};